class CareerVacancies extends HTMLElement {
  connectedCallback() {
    this.drawer = this.querySelector('.career-vacancies__drawer');
    this.drawerContent = this.querySelector('.career-vacancies__drawer-content');
    this.drawerClose = this.querySelector('.career-vacancies__drawer-close');
    this.pills = Array.from(this.querySelectorAll('.current-openings__filter-pill'));
    this.grid = this.querySelector('.current-openings__grid');

    this._onPillClick = this._onPillClick.bind(this);
    this._onJobPostLinkClick = this._onJobPostLinkClick.bind(this);
    this._onDrawerClose = this._onDrawerClose.bind(this);
    this._onDrawerOverlayClick = this._onDrawerOverlayClick.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);

    this.pills.forEach(function (pill) {
      pill.addEventListener('click', this._onPillClick);
    }, this);

    this.querySelectorAll('[data-job-post-link]').forEach(function (link) {
      link.addEventListener('click', this._onJobPostLinkClick);
    }, this);

    if (this.drawerClose) {
      this.drawerClose.addEventListener('click', this._onDrawerClose);
    }

    if (this.drawer) {
      this.drawer.addEventListener('click', this._onDrawerOverlayClick);
    }

    document.addEventListener('keydown', this._onKeyDown);
  }

  disconnectedCallback() {
    this.pills.forEach(function (pill) {
      pill.removeEventListener('click', this._onPillClick);
    }, this);

    this.querySelectorAll('[data-job-post-link]').forEach(function (link) {
      link.removeEventListener('click', this._onJobPostLinkClick);
    }, this);

    if (this.drawerClose) {
      this.drawerClose.removeEventListener('click', this._onDrawerClose);
    }

    if (this.drawer) {
      this.drawer.removeEventListener('click', this._onDrawerOverlayClick);
    }

    document.removeEventListener('keydown', this._onKeyDown);
  }

  _onPillClick(event) {
    var pill = event.currentTarget;
    var filter = pill.dataset.filter;

    this.pills.forEach(function (p) {
      var isActive = p === pill;
      p.classList.toggle('is-active', isActive);
      p.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    if (!this.grid) return;

    this.grid.querySelectorAll('.current-openings__card-wrap').forEach(function (card) {
      var matches = filter === 'all' || card.dataset.department === filter;
      card.classList.toggle('hidden', !matches);
    });
  }

  _onJobPostLinkClick(event) {
    event.preventDefault();

    var card = event.currentTarget.closest('.current-openings__card');
    if (!card) return;

    var content = card.querySelector('.current-openings__card-content');
    if (!content || !this.drawerContent) return;

    this.drawerContent.innerHTML = content.innerHTML;
    this._openDrawer();
  }

  _openDrawer() {
    if (!this.drawer) return;
    this.drawer.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    this.drawerClose && this.drawerClose.focus();
  }

  _closeDrawer() {
    if (!this.drawer) return;
    this.drawer.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
  }

  _onDrawerClose() {
    this._closeDrawer();
  }

  _onDrawerOverlayClick(event) {
    var inner = this.querySelector('.career-vacancies__drawer-inner');
    if (inner && !inner.contains(event.target)) {
      this._closeDrawer();
    }
  }

  _onKeyDown(event) {
    if (event.key === 'Escape' && this.drawer && this.drawer.classList.contains('is-open')) {
      this._closeDrawer();
    }
  }
}

if (!customElements.get('career-vacancies')) {
  customElements.define('career-vacancies', CareerVacancies);
}